export function enableBodyScroll () {
  const { body } = document
  body.style.overflow = ''
  body.style.width = ''
  body.style.position = ''
  body.style.top = ''
  window.scrollTo(0, parseInt(body.dataset.scrollPosition, 10))
  delete body.dataset.scrollPosition
}

export function disableBodyScroll () {
  const { body } = document
  const actualBodyScrollPosition = window.pageYOffset.toString()
  body.dataset.scrollPosition = actualBodyScrollPosition
  body.style.overflow = 'hidden'
  body.style.width = '100%'
  body.style.top = `-${actualBodyScrollPosition}px`
  body.style.position = 'fixed'
}
